import NdisClaimContainer from "./NdisClaim.container";

export default NdisClaimContainer;
